import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WallDecorFrontSceneComponent } from './wall-decor-front-scene/wall-decor-front-scene.component';
import { MatIconModule } from '@angular/material/icon';
import { ColorPickerDirective } from 'ngx-color-picker';
import { ButtonModule } from '../../button/button/button.module';
import { WallDecorScenesListComponent } from './wall-decor-scenes-list/wall-decor-scenes-list.component';
import { WallDecorSceneCreatorComponent } from './wall-decor-scene-creator/wall-decor-scene-creator.component';
import { MatSelectModule } from '@angular/material/select';
import { ReactiveFormsModule } from '@angular/forms';
import { WallDecorIconComponent } from './wall-decor-icon/wall-decor-icon.component';
import { CalcSvgXPositionPipe } from './wall-decor-icon/calc-svg-xposition.pipe';
import { CalcSvgYPositionPipe } from './wall-decor-icon/calc-svg-yposition.pipe';
import { EditWallDecorPieceComponent } from './edit-wall-decor-piece/edit-wall-decor-piece.component';
import { GetPhotoGroupFromPhotoIdPipe } from './edit-wall-decor-piece/get-photo-group-from-photo-id.pipe';
import { ImageLoaderModule } from 'ZalamoLibrary/src/lib/core/image/image-loader/image-loader.module';
import { CropCanvasPieceImagePipe } from './edit-wall-decor-piece/crop-canvas-piece-image.pipe';
import { WallPieceCropComponent } from './edit-wall-decor-piece/wall-piece-crop/wall-piece-crop.component';
import { PinchZoomModule } from 'ZalamoLibrary/src/lib/ui/ivypinch_pro/pinch-zoom.module';
import { SideDialogModule } from 'ZalamoLibrary/src/lib/ui/side-dialog';
import { CalcWallDecorScenePricePipe } from './calc-wall-decor-scene-price.pipe';
import { WallDecorPreviewComponent } from './wall-decor-preview/wall-decor-preview.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { UsedBeforePipe } from './edit-wall-decor-piece/used-before.pipe';
import { ResponsivenessModule } from '@ui/responsive/responsiveness/responsiveness.module';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@NgModule({
  declarations: [
    WallDecorFrontSceneComponent,
    WallDecorScenesListComponent,
    WallDecorSceneCreatorComponent,
    WallDecorIconComponent,
    CalcSvgXPositionPipe,
    CalcSvgYPositionPipe,
    EditWallDecorPieceComponent,
    GetPhotoGroupFromPhotoIdPipe,
    CropCanvasPieceImagePipe,
    WallPieceCropComponent,
    CalcWallDecorScenePricePipe,
    WallDecorPreviewComponent,
    UsedBeforePipe,
  ],
  exports: [
    WallDecorSceneCreatorComponent,
    CropCanvasPieceImagePipe,
    WallPieceCropComponent,
    GetPhotoGroupFromPhotoIdPipe,
    WallDecorPreviewComponent,
  ],
  imports: [
    CommonModule,
    MatIconModule,
    ColorPickerDirective,
    ButtonModule,
    MatSelectModule,
    ReactiveFormsModule,
    ImageLoaderModule,
    PinchZoomModule,
    SideDialogModule,
    MatTooltipModule,
    ResponsivenessModule,
    MatProgressBarModule,
  ],
})
export class WallDecorFrontModule {}
